var _circle, _path, _circle2, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5894,
    r: 32,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1981 38.1329C46.8416 45.3632 40.0325 50.5894 32 50.5894C23.8093 50.5894 16.8906 45.1553 14.6678 37.7034M50 30.8308C49.6455 27.0868 48.1442 23.6759 45.8503 20.9516M43.6235 18.7298C40.893 16.441 37.4744 14.9431 33.722 14.5894M30.278 14.5894C26.5256 14.9431 23.107 16.441 20.3765 18.7298M18.1497 20.9516C15.8558 23.6759 14.3545 27.0868 14 30.8308",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9346,
    cy: 32.524,
    r: 9.93464,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M32 25.7974C26.7273 25.7974 22.4196 29.6688 22.028 34.5894C22.014 34.2999 22 34.0225 22 33.721C22 27.5703 26.4755 22.5894 32 22.5894C37.5245 22.5894 42 27.5823 42 33.721C42 34.0105 42 34.2999 41.972 34.5894C41.5804 29.6688 37.2587 25.7974 32 25.7974Z",
    fill: "#1A1E23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3077 29.4401C34.1605 28.1502 32.7566 27.8607 31.5263 27.856C29.9174 27.8489 28.3112 29.2306 28.879 30.6994C29.4363 32.1423 31.3397 32.4272 32.7225 32.9403C33.3219 33.1616 34.0212 33.4629 34.355 33.9878C34.7678 34.6398 34.66 35.4236 34.2052 36.0333C33.7504 36.6429 33.0222 37.0054 32.1993 37.1325C30.8638 37.3396 28.95 37.0501 28.4847 35.7155C28.4058 35.4895 28.3795 35.2518 28.39 35.0164",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4992 26.6106V38.4375",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7715 41.5632L13.6095 36.3794L13.7766 35.9082L19.4316 37.9133",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.2ba133a9afb774c564fa6499a5ca3c8f.svg";
export { ForwardRef as ReactComponent };